$('.compare-item select').each(function() {
	var selectedBike = $(this).find('option:selected').val();
	$(this).parent().next().children('.compare-bike').addClass('hidden');
	$(this).parent().next().children('.' + selectedBike).removeClass('hidden');
});
$('.compare-item select').each(function() {
	$(this).change(function(){
		var selectedBike = $(this).find('option:selected').val();
		$(this).parent().next().children('.compare-bike').addClass('hidden');
		$(this).parent().next().children('.' + selectedBike).removeClass('hidden');
		$('.compare-slider').flickity('resize');
	});
});

if ($("#compare-bicycles ").length) {
	var quickOverviewHeight = $('.bisou .quick-overview').height();
	var frameSet = $('.bisou .frame-set').height();
	var driveTrainHeight = $('.bisou .drivetrain').height();
	var components = $('.bisou .components').height();
	var wheelsHeight = $('.bisou .wheels').height();
	var setting1 = $('.bisou .specification.quick-overview .spec-description:nth-child(7)').height();
	var setting2 = $('.compare-item:nth-child(2) .classic-sport-26 .specification.components .spec-description:nth-child(7)').height();
	var driveTrainSettings = $('.compare-item:nth-child(2) .classic-sport-26 .specification.drivetrain .spec-description:nth-child(5)').height();
	var componentsSettings2 = $('.compare-item:nth-child(1) .bisou .specification.components .spec-description:nth-child(9)').height();
	var wheelsSettings = $('.compare-item:nth-child(2) .classic-sport-26 .specification.wheels .spec-description:nth-child(3)').height();
	$('.compare-bike .quick-overview').height(quickOverviewHeight);
	$('.compare-bike .frame-set').height(frameSet);
	$('.compare-bike .drivetrain').height(driveTrainHeight);
	$('.compare-bike .components').height(components);
	$('.compare-bike .wheels').height(wheelsHeight);
	$('.compare-bike .specification.quick-overview .spec-description:nth-child(7)').css('min-height', setting1);
	$('.compare-bike .specification.components .spec-description:nth-child(7)').css('min-height', setting2);
	$('.compare-bike .specification.drivetrain .spec-description:nth-child(5)').css('min-height', driveTrainSettings);
	$('.compare-bike .specification.components .spec-description:nth-child(9)').css('min-height', componentsSettings2);
	$('.compare-bike .specification.wheels .spec-description:nth-child(3)').css('min-height', wheelsSettings);
}

if ($("#compare-kids-bicycles").length) {
	var kidsBikeOverview = $('.compare-item:nth-child(2) .paddle .specification.quick-overview .spec-description:nth-child(3)').height();
	var kidsBikeOverview2 = $('.compare-item:nth-child(1) .specification.quick-overview .spec-description:nth-child(5)').height();
	var kidsBikeComponents = $('.compare-item:nth-child(1) .specification.components .spec-description:last-child').height();
	$('.compare-item:nth-child(1) .little-tokyobike .specification.quick-overview .spec-description:nth-child(3)').css('min-height', kidsBikeOverview);
	$('.compare-item:nth-child(2) .specification.quick-overview .spec-description:nth-child(5)').css('min-height', kidsBikeOverview2);
	$('.compare-item:nth-child(2) .specification.components .spec-description:last-child').css('min-height', kidsBikeComponents);
}




$('.compare-section').each(function(obj) {
	var options = {
		fade: true,
		pageDots: false,
		prevNextButtons: false,
		imagesLoaded: true,
		draggable: false	
	};
	var $carousel = $(this).find('.compare-slider').flickity(options);
	// Flickity instance
	var flkty = $carousel.data('flickity');
	// elements
	var $cellButtonGroup = $(this).find('.color-selections-wrapper');
	var $cellButtons = $cellButtonGroup.find('.color-choice-wrap');
	
	// update selected cellButtons
	$carousel.on( 'select.flickity', function() {
		$cellButtons.filter('.is-selected')
			.removeClass('is-selected');
		$cellButtons.eq( flkty.selectedIndex )
			.addClass('is-selected');
	});
	
	// select cell on button click
	$cellButtonGroup.on( 'click', '.color-choice-wrap', function() {
		var index = $(this).index();
		$carousel.flickity( 'select', index );
	});
});

var isMobile = window.matchMedia("only screen and (max-width: 768px)");
// console.log('run mobile scripts')
if (isMobile.matches) {
	$(document).scroll(function() {
		var y = $(this).scrollTop();
		if (y > 283) {
			$('.select-wrap').addClass('fixed');
			$('.color-text').addClass('fade-out');
			$('.url').addClass('fade-in');
			$('.compare-section .color-section.product-info-spacing').addClass('move-up');
		} else {
			$('.select-wrap').removeClass('fixed');
			$('.color-text').removeClass('fade-out');
			$('.compare-section .color-section.product-info-spacing').removeClass('move-up');
			$('.url').removeClass('fade-in');
		}
		if (y > 2582) {
			$('.bg').fadeOut();
		} else {
			$('.bg').fadeIn();
		}
	});
} else {
	$(document).scroll(function() {
		var y = $(this).scrollTop();
		if (y > 400) {
			$('.color-text').addClass('fade-out');
			$('.url').addClass('fade-in');
			$('.compare-section .color-section.product-info-spacing').addClass('move-up');
			$('.compare-section.sticky, .compare-item .select-wrap').addClass('small-height');
		} else {
			$('.color-text').removeClass('fade-out');
			$('.compare-section .color-section.product-info-spacing').removeClass('move-up');
			$('.url').removeClass('fade-in');
			$('.compare-section.sticky, .compare-item .select-wrap').removeClass('small-height');
		}
	});	
	if ($("#compare-kids-bicycles").length) {
		var kidsBikeSize = $('.compare-item:nth-child(2) .paddle .quick-overview').height();
		$('.little-tokyobike .quick-overview').height(kidsBikeSize);
	}
}









